export const HOME = { emergentLink: "emergent-link" };
export const NAV = {
  logo: "nav-logo",
  linkProjects: "nav-link-projects",
  linkAbout: "nav-link-about",
  linkProgress: "nav-link-progress",
  linkContact: "nav-link-contact",
  linkAdmin: "nav-link-admin",
  cta: "nav-cta",
  search: "nav-search",
  mobileToggle: "nav-mobile-toggle",
};
export const HERO = {
  section: "hero-section",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};
export const PROJECTS = {
  section: "projects-section",
  card: (slug) => `project-card-${slug}`,
  viewAll: "projects-view-all",
};
export const ENQUIRY = {
  form: "enquiry-form",
  name: "enquiry-name",
  email: "enquiry-email",
  phone: "enquiry-phone",
  project: "enquiry-project",
  message: "enquiry-message",
  submit: "enquiry-submit",
};
export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabEnquiries: "admin-tab-enquiries",
  tabProjects: "admin-tab-projects",
  createProject: "admin-create-project",
};
